import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { VolunteerMentorSignup } from '../../../../../../interfaces';
import { AppService } from '../../../../../../services';
import { VolunteerDialogDataService } from '../../volunteer-dialog-data.service';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';

export function getSetup(util: UtilityService, app: AppService, dialog: DialogService, dialogDataService: VolunteerDialogDataService): GridSetup<VolunteerMentorSignup> {

	return {
		rowName: { singular: 'Mentor Sign-up', plural: 'Mentor Sign-ups' },
		getRowKey: row => '' + row.trimesterId,
		stateKey: 'volunteer-dialog-mentor-signups-grid',
		actions: [],
		buttons: getButtons(dialog, dialogDataService),
		columns: getColumns(util, app),
	}
}
